
const OrderRoutes = [
  {
    path: '/ecommerce/orders',
    name: 'orders',
    component: () => import(/* webpackChunkName: "order" */ './views/OrderView.vue'),
    meta: {
      requiresAuth: true,
      breadCrumbs: [
        {
          name: 'Orders',
          path: '/ecommerce/orders',
        },
      ],
    },
    children: [
      {
        path: '',
        name: 'orders',
        component: () => import(/* webpackChunkName: "order" */ './components/Orders.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Orders',
              path: '/ecommerce/orders',
            },
          ],
        },
      },
      {
        path: 'new',
        name: 'orders',
        component: () => import(/* webpackChunkName: "order" */ './components/NewOrder.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Orders',
              path: '/ecommerce/orders',
            },
            {
              name: 'New Orders',
              path: '',
            },
          ],
        },
      },
      {
        path: ':id/details',
        name: 'order-details',
        component: () => import(/* webpackChunkName: "order" */ './components/OrderDetails.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Order Details',
              path: '/ecommerce/orders/:id/details',
            },
          ],
        },
      },
      {
        path: ':id/edit',
        name: 'edit-order',
        component: () => import(/* webpackChunkName: "order" */ './components/UpdateOrder.vue'),
        meta: {
          requiresAuth: true,
          breadCrumbs: [
            {
              name: 'Edit Order',
              path: '/ecommerce/orders/:id/edit',
            },
          ],
        },
      },
    ],
  },
];

export default OrderRoutes;
